const services = [
  {
    icon: 'ri-calculator-line',
    title: 'Contabilidade Completa',
    badge: 'Essencial',
    badgeClass: 'bg-[#0f2651]/8 text-[#0f2651]',
    desc: 'Escrituração contábil, balancetes, demonstrações financeiras e gestão de obrigações acessórias com precisão e rigor.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Assessoria Fiscal e Tributária',
    badge: 'Popular',
    badgeClass: 'bg-[#c9a84c]/10 text-[#a07a28]',
    desc: 'Acompanhamento das obrigações fiscais, declarações e apurações com foco em conformidade e eficiência.',
  },
  {
    icon: 'ri-funds-line',
    title: 'Planejamento Tributário',
    badge: 'Estratégico',
    badgeClass: 'bg-emerald-50 text-emerald-700',
    desc: 'Estruturação do enquadramento tributário ideal para reduzir a carga de impostos de forma legal e sustentável.',
  },
  {
    icon: 'ri-search-2-line',
    title: 'Revisão e Diagnóstico Fiscal',
    badge: 'Análise',
    badgeClass: 'bg-rose-50 text-rose-700',
    desc: 'Análise completa dos processos fiscais e contábeis para identificar erros, inconsistências e oportunidades.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regularização de Pendências',
    badge: 'Solução',
    badgeClass: 'bg-sky-50 text-sky-700',
    desc: 'Solução de passivos fiscais, parcelamentos e negociação de débitos tributários com a Receita Federal e estados.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Apoio à Tomada de Decisão',
    badge: 'Estratégico',
    badgeClass: 'bg-emerald-50 text-emerald-700',
    desc: 'Relatórios gerenciais e análises financeiras que transformam números em insights para decisões mais assertivas.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Demandas Societárias',
    badge: 'Societário',
    badgeClass: 'bg-violet-50 text-violet-700',
    desc: 'Constituição, alteração e dissolução de empresas, contratos sociais e registros nas juntas comerciais.',
  },
  {
    icon: 'ri-user-3-line',
    title: 'Declaração de IRPF',
    badge: 'Pessoa Física',
    badgeClass: 'bg-orange-50 text-orange-700',
    desc: 'Declaração de Imposto de Renda Pessoa Física com atenção a todos os rendimentos, bens e direitos.',
  },
  {
    icon: 'ri-coin-line',
    title: 'Recuperação de Créditos Tributários',
    badge: 'Recuperação',
    badgeClass: 'bg-teal-50 text-teal-700',
    desc: 'Identificação e recuperação de créditos pagos a maior, com análise minuciosa das obrigações fiscais e pedidos de restituição ou compensação.',
  },
];

export default function ServicesSection() {
  return (
    <section id="servicos" className="pt-12 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#c9a84c] text-sm font-bold tracking-widest uppercase">
            Nossos Serviços
          </span>
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#0f2651] mt-3 mb-5">
            O que fazemos por<span className="text-[#c9a84c]"> você</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Soluções contábeis e tributárias completas, aplicando visão de auditoria em cada etapa
            do trabalho.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className="group bg-[#c9a84c]/20 border border-[#c9a84c]/45 rounded-lg p-7 hover:border-[#c9a84c]/75 hover:bg-[#c9a84c]/30 transition-all duration-300 cursor-default"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center bg-[#0f2651] rounded-lg text-white group-hover:bg-[#c9a84c] transition-colors duration-300">
                  <i className={`${s.icon} text-xl`} />
                </div>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${s.badgeClass}`}>
                  {s.badge}
                </span>
              </div>
              <h3 className="text-xl font-bold text-[#0f2651] mb-2">{s.title}</h3>
              <p className="text-gray-500 text-base leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#0f2651] rounded-xl px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-serif text-2xl font-bold text-white mb-2">
              O problema que resolvemos
            </h3>
            <p className="text-white/60 text-base">
              Muitas empresas pagam mais impostos do que deveriam, sem saber.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              'Pagam impostos em excesso',
              'Sem controle real dos números',
              'Expostas a riscos fiscais',
              'Decisões sem base confiável',
            ].map((item) => (
              <div key={item} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-[#c9a84c] flex-shrink-0">
                  <i className="ri-error-warning-line text-base" />
                </div>
                <span className="text-white/70 text-sm">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
